module.exports = __webpack_public_path__ + "img/i.32b3a06c.jpg";